// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list-actions {
  margin-top: 10px;
}

.item-list-grid-wrapper {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  margin-bottom: 0px;
}

.item-list-grid-wrapper .ag-root-wrapper {
  border: none !important;
}

.item-list-grid-wrapper .ag-header {
  background-color: #eef3f7;
  border-bottom: 1px solid #d8e0ea;
  border-radius: 0 !important;
}

.item-list-grid-wrapper .ag-header-cell {
  border-right: none;
  font-weight: 500;
}

.item-list-grid-wrapper .ag-header-row {
  border-bottom: none;
}

.item-list-grid-wrapper .ag-row,
.item-list-grid-wrapper .ag-cell {
  border-bottom: 1px solid #eef3f7;
}

.item-list-grid-wrapper .ag-cell {
  border-right: none;
}

.item-list-grid-wrapper .ag-header-viewport,
.item-list-grid-wrapper .ag-header-container {
  border-radius: 0 !important;
}

.item-list-grid-wrapper .ag-header-cell:first-child {
  border-top-left-radius: 0 !important;
}

.item-list-grid-wrapper .ag-header-cell:last-child {
  border-top-right-radius: 0 !important;
}

.inventory-check-btn {
  padding: 8px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

.highlight-row {
  background-color: rgba(255, 215, 0, 0.35);
}

.inventory-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  /* mezera nad gridem */
}

.inventory-toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.inventory-toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.inventory-select {
  min-width: 250px;
  padding: 6px 8px;
  font-size: 15px;
  font-weight: 500;
}

.inventory-date-label {
  font-size: 0.95rem;
  opacity: 0.8;
}

.inventory-status {
  font-weight: 600;
}

.inventory-status--done {
  color: #16a34a;
}

.inventory-status--undone {
  color: #dc2626;
}

.inventory-new-btn {
  padding: 13px;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
}

.inv-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.inv-modal {
  width: min(520px, calc(100% - 32px));
  background: #fff;
  /* border-radius: 12px; */
  padding: 18px 18px 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);
}

.inv-modal-title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 40px;
}

.inv-modal-desc {
  font-size: 16px;
  margin-bottom: 16px;
}

.inv-modal-actions1 {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.inv-modal-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}

.inv-modal-actions-left,
.inv-modal-actions-right {
  display: flex;
  gap: 10px;
}

.inv-btn {
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
}

.inv-btn-primary {
  border-color: transparent;
  background: #2d6cdf;
  color: #fff;
}

.inv-btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/web/component/Inventory2/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".item-list-actions {\r\n  margin-top: 10px;\r\n}\r\n\r\n.item-list-grid-wrapper {\r\n  flex: 1;\r\n  min-height: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-root-wrapper {\r\n  border: none !important;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header {\r\n  background-color: #eef3f7;\r\n  border-bottom: 1px solid #d8e0ea;\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-cell {\r\n  border-right: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-row {\r\n  border-bottom: none;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-row,\r\n.item-list-grid-wrapper .ag-cell {\r\n  border-bottom: 1px solid #eef3f7;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-cell {\r\n  border-right: none;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-viewport,\r\n.item-list-grid-wrapper .ag-header-container {\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-cell:first-child {\r\n  border-top-left-radius: 0 !important;\r\n}\r\n\r\n.item-list-grid-wrapper .ag-header-cell:last-child {\r\n  border-top-right-radius: 0 !important;\r\n}\r\n\r\n.inventory-check-btn {\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.highlight-row {\r\n  background-color: rgba(255, 215, 0, 0.35);\r\n}\r\n\r\n.inventory-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n  /* mezera nad gridem */\r\n}\r\n\r\n.inventory-toolbar-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.inventory-toolbar-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.inventory-select {\r\n  min-width: 250px;\r\n  padding: 6px 8px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n}\r\n\r\n.inventory-date-label {\r\n  font-size: 0.95rem;\r\n  opacity: 0.8;\r\n}\r\n\r\n.inventory-status {\r\n  font-weight: 600;\r\n}\r\n\r\n.inventory-status--done {\r\n  color: #16a34a;\r\n}\r\n\r\n.inventory-status--undone {\r\n  color: #dc2626;\r\n}\r\n\r\n.inventory-new-btn {\r\n  padding: 13px;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n}\r\n\r\n.inv-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, .45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.inv-modal {\r\n  width: min(520px, calc(100% - 32px));\r\n  background: #fff;\r\n  /* border-radius: 12px; */\r\n  padding: 18px 18px 14px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);\r\n}\r\n\r\n.inv-modal-title {\r\n  font-size: 17px;\r\n  font-weight: 500;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.inv-modal-desc {\r\n  font-size: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.inv-modal-actions1 {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.inv-modal-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 16px;\r\n}\r\n\r\n.inv-modal-actions-left,\r\n.inv-modal-actions-right {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.inv-btn {\r\n  padding: 10px 14px;\r\n  border-radius: 10px;\r\n  border: 1px solid #ddd;\r\n  background: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.inv-btn-primary {\r\n  border-color: transparent;\r\n  background: #2d6cdf;\r\n  color: #fff;\r\n}\r\n\r\n.inv-btn:disabled {\r\n  opacity: .6;\r\n  cursor: not-allowed;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
